// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2luJ2","info":"PatientInfo_info__2Zmk4"};